// Local translations
export const T = {
  en_GB: {
    description:
      "Define the client preferences for this collection. Clients answer each one with yes or no during a flow.",
    addPreference: "Add Preference",
    noPreferences: 'No client preferences defined. Click "Add Preference" to create one.',
    name: "Name",
    actions: "Actions",
    preferenceName: "Preference name",
    placeholder: "e.g., Emerging markets",
    edit: "Edit",
    save: "Save",
    deletePreference: "Delete Preference",
    deleteConfirmation:
      "Are you sure you want to delete this client preference? This action cannot be undone.",
    delete: "Delete",
    cancel: "Cancel",
    saved: "Saved",
    preferenceAdded: "Client preference added",
    preferenceDeleted: "Client preference deleted",
    error: "Error",
    failedToAdd: "Failed to add client preference",
    failedToUpdate: "Failed to update client preference",
    failedToDelete: "Failed to delete client preference",
  },
  nb_NO: {
    description:
      "Definer kundepreferansene for denne samlingen. Kunder besvarer hver av dem med ja eller nei i en flyt.",
    addPreference: "Legg til preferanse",
    noPreferences:
      'Ingen kundepreferanser definert. Klikk "Legg til preferanse" for å opprette en.',
    name: "Navn",
    actions: "Handlinger",
    preferenceName: "Preferansenavn",
    placeholder: "f.eks. Fremvoksende markeder",
    edit: "Rediger",
    save: "Lagre",
    deletePreference: "Slett preferanse",
    deleteConfirmation:
      "Er du sikker på at du vil slette denne kundepreferansen? Denne handlingen kan ikke angres.",
    delete: "Slett",
    cancel: "Avbryt",
    saved: "Lagret",
    preferenceAdded: "Kundepreferanse lagt til",
    preferenceDeleted: "Kundepreferanse slettet",
    error: "Feil",
    failedToAdd: "Kunne ikke legge til kundepreferanse",
    failedToUpdate: "Kunne ikke oppdatere kundepreferanse",
    failedToDelete: "Kunne ikke slette kundepreferanse",
  },
} as const;
